// Angular
import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'kt-confirm-denial-dialog',
  templateUrl: './confirm-denial-dialog.component.html',
})
export class ConfirmDenialComponent implements OnInit {
  // Public properties
  viewLoading = false;
  @ViewChild('confirmButton') confirmButton: ElementRef;
  @ViewChild('cancelButton') cancelButton: ElementRef;
  focusedButton = 'confirm';
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDenialComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.form = new FormGroup({
      reason: new FormControl('', Validators.required),
    });
  }
  @HostListener('window:keydown.enter', ['$event'])
  @HostListener('window:keydown.arrowleft', ['$event'])
  @HostListener('window:keydown.arrowright', ['$event'])
  onEnterKey(event: KeyboardEvent) {
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault(); // prevent default browser scrolling behavior
      this.focusedButton = this.focusedButton === 'confirm' ? 'cancel' : 'confirm';
    } else if (event.key === 'Enter') {
      if (this.focusedButton === 'confirm') {
        this.onYesClick();
      } else {
        this.onNoClick();
      }
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close({
      reason: this.form.get('reason').value,
    });
  }
}
